import { createContext } from 'react';
import { PaymentGateway } from '../api/applications/types/applications.types';

type Customization = {
	primaryColor: string;
	secondaryColor: string;
	theme: {
		id: number;
		title: 'LIGHT' | 'DARK' | 'CUSTOM';
	};
	logo: string;
	url: string;
};

type Finance = {
	isCurseducaPayConfigured: boolean;
	isAnticipationEnabled: boolean;
	isAntifraudEnabled: boolean;
	isAddressRequired: boolean;
	isBoletoNPixInstallmentEnabled: false;
	shouldDisplayTerms: false;
	// Gateway persistente da plataforma (vindo de /applications/params). Decide
	// onde o checkout tokeniza o cartão. Ver api/creditCards/tokenize.ts.
	gateway?: PaymentGateway;
};

export type IApplicationContext = {
	name?: string;

	customization?: Customization;

	finance?: Finance;

	integrations?: {
		whatsappUrl: string;
	};
};

export const ApplicationContext = createContext<IApplicationContext>({});
